// @flow

import React from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import {
  ActiveLink,
  BackLink,
  List,
  ListItem,
  Nav,
  Select,
} from './atoms';
import { LinkStyled } from '../../link';

type Category = {
  name: string,
  url: string,
  active?: boolean,
};

type OwnProps = {|
  categories: Array<Category>,
  defaultDropdownOption?: string,
  parentName?: ?string,
  parentUrl?: ?string,
|};

type DispatchProps = {|
  redirect: (url: string) => void,
|};

type Props = {|
  ...OwnProps,
  ...DispatchProps,
|};

const SubCategoryList = ({
  categories,
  defaultDropdownOption,
  parentName,
  parentUrl,
  redirect,
}: Props) => {
  const activeCategory = categories.find(category => category.active);
  return (
    <section>
      {parentName && (
        <BackLink href={parentUrl}>{parentName}</BackLink>
      )}
      <Select
        defaultValue={activeCategory && activeCategory.url}
        onChange={({ target: { value } }) => value && redirect(value)}
      >
        {defaultDropdownOption && <option>{defaultDropdownOption}</option>}
        {categories.map(({ name, url }) => (
          <option key={url} value={url}>{name}</option>
        ))}
      </Select>
      <Nav>
        <List>
          {categories.map(({ name, url, active }) => {
            const LinkComponent = active ? ActiveLink : LinkStyled;
            return (
              <ListItem key={url}>
                <LinkComponent href={url} preventScrollTop>{name}</LinkComponent>
              </ListItem>
            );
          })}
        </List>
      </Nav>
    </section>
  );
};

SubCategoryList.defaultProps = {
  defaultDropdownOption: '',
  parentName: '',
  parentUrl: '',
};

const mapDispatchToProps = (dispatch: Function): DispatchProps => ({
  redirect: (url: string) => dispatch(push(url)),
});

export default connect<Props, OwnProps, void, DispatchProps, any, any>(
  null,
  mapDispatchToProps,
)(SubCategoryList);
